import { CheckCircle2, Sparkles, Database, AlertTriangle, CircleCheck, OctagonAlert } from "lucide-react";
import { STATUS_LABEL } from "@/lib/format";

const base = "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-medium border whitespace-nowrap";

export const RealBadge = ({ label = "Dado real da conta" }) => (
  <span data-testid="badge-real-data" className={`${base} bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/30`}>
    <span className="relative flex h-1.5 w-1.5"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-500 opacity-60" /><span className="relative h-1.5 w-1.5 rounded-full bg-emerald-500" /></span>
    <Database className="h-3 w-3" />{label}
  </span>
);

export const AIBadge = ({ label = "Sugestão da IA" }) => (
  <span data-testid="badge-ai-suggestion" className={`${base} bg-primary/10 text-primary border-primary/30`}>
    <Sparkles className="h-3 w-3" />{label}
  </span>
);

export const ActionBadge = ({ label = "Ação executada" }) => (
  <span data-testid="badge-action-executed" className={`${base} bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/30`}>
    <CheckCircle2 className="h-3 w-3" />{label}
  </span>
);

const PRIORITY = { alta: "bg-rose-500/10 text-rose-600 dark:text-rose-300 border-rose-500/30", media: "bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/30", baixa: "bg-slate-500/10 text-slate-600 dark:text-slate-300 border-slate-500/30" };
export const PriorityBadge = ({ p }) => {
  const k = (p || "media").toLowerCase().replace("é", "e");
  return <span className={`${base} ${PRIORITY[k] || PRIORITY.media}`}>Prioridade {k === "media" ? "média" : k}</span>;
};

const LEVEL = {
  critical: { c: "text-rose-500", I: OctagonAlert, l: "Crítico" },
  warning: { c: "text-amber-500", I: AlertTriangle, l: "Atenção" },
  ok: { c: "text-emerald-500", I: CircleCheck, l: "OK" },
};
export const LevelIcon = ({ level }) => {
  const L = LEVEL[level] || LEVEL.warning;
  return <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${L.c}`}><L.I className="h-4 w-4" />{L.l}</span>;
};

const SUB = { trial: "bg-indigo-500/10 text-indigo-600 dark:text-indigo-300", active: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-300", past_due: "bg-amber-500/10 text-amber-600", cancelled: "bg-slate-500/10 text-slate-500", expired: "bg-rose-500/10 text-rose-500", suspended: "bg-rose-500/10 text-rose-500" };
export const SubStatus = ({ s }) => <span data-testid="subscription-status-badge" className={`${base} border-transparent ${SUB[s] || SUB.cancelled}`}>{STATUS_LABEL[s] || s}</span>;

export const ScoreBadge = ({ score }) => (
  <div data-testid="internal-score" className="inline-flex flex-col gap-1">
    <span className="text-sm text-muted-foreground">Pontuação da estrutura</span>
    <span className="text-4xl font-semibold text-primary">{score}<span className="text-lg text-muted-foreground">/100</span></span>
    <span className="text-[11px] text-muted-foreground">Pontuação interna da plataforma — não é uma pontuação oficial do Google.</span>
  </div>
);
